var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 619,
    height: 244,
    viewBox: "0 0 619 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3789 2.45117C9.89128 97.2577 118.135 160.236 191.038 161.011C253.611 176.652 351.179 48.9603 443.007 60.0871C543.77 72.2964 568.278 190.1 589.005 234.02",
    stroke: "#A3A3A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M591.924 242.349C590.289 241.926 588.697 241.032 587.143 240.38C583.627 238.903 580.076 237.911 576.383 236.97",
    stroke: "#A3A3A3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M592.537 241.87C592.875 240.986 593.542 240.173 594.035 239.374C594.887 237.991 595.709 236.596 596.724 235.324C597.444 234.421 598.329 233.714 599.142 232.918",
    stroke: "#A3A3A3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepArrow);
export default __webpack_public_path__ + "static/media/step-arrow.ed540442bf35612ffde3a1518c81179c.svg";
export { ForwardRef as ReactComponent };